// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SelectLocalization_buttonContainer__OMI-1"};